import {
  NEWSLETTER_SIGNUP_LOAD,
  NEWSLETTER_SIGNUP_MESSAGE,
  NEWSLETTER_SIGNUP_ERROR,
} from '../constants';

const DEFAULT_STATE = {
  status: 'init',
  newsletterSignupData: null,
  voucherCode: '',
  showSignupMessage: false,
};

export const newsletterSignup = (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case NEWSLETTER_SIGNUP_LOAD:
    case NEWSLETTER_SIGNUP_MESSAGE:
    case NEWSLETTER_SIGNUP_ERROR:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};
